import { render, staticRenderFns } from "./SpecificationInfo.vue?vue&type=template&id=1e7d6de8&scoped=true&"
import script from "./SpecificationInfo.vue?vue&type=script&lang=js&"
export * from "./SpecificationInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationInfo.vue?vue&type=style&index=0&id=1e7d6de8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d6de8",
  null
  
)

export default component.exports